<template>
  <div class="main-bg">
    <div class="wrap">
      <div class="container">
        <div class="content">
          <div class="logo margin-b" @click="goHome">
            <img :src="require(`@/assets/theme_gold/images/logo_katsuwin.png`)" alt="Katsuwin Logo">
          </div>
          <!-- <div class="login-frame" /> -->
          <landing v-if="!$store.state.user.isCampaignLoginActive && !$store.state.user.isCampaignForgetActive && !$store.state.user.isCampaignDepositActive" />
          <login v-if="$store.state.user.isCampaignLoginActive" />
          <forget v-if="$store.state.user.isCampaignForgetActive" />
          <deposit v-if="$store.state.user.isCampaignDepositActive" />
          <div v-if="!$store.state.user.isCampaignLoginActive && !$store.state.user.isCampaignForgetActive && !$store.state.user.isCampaignDepositActive" class="d-flex align-items-center justify-content-center">
            <button v-if="$store.getters.token" class="btn btn-style-primary-golden btn-w-xl" @click="goDeposit()">
              今すぐ入金
            </button>
            <button v-if="!$store.getters.token" class="btn btn-style-primary-golden btn-w-xl" @click="goLogin()">
              {{ $t('Bao.login') }}
            </button>
          </div>
          <section v-if="!$store.state.user.isCampaignLoginActive && !$store.state.user.isCampaignForgetActive && !$store.state.user.isCampaignDepositActive" class="depiction">
            <ul>
              <li>「利用規約」および「キャンペーン規約と条件」が適用されます。</li>
              <li> 当キャンペーンは、KatsuWINよりこのキャンペーンのお知らせメールを受け取られたお客様のみに適用されます。</li>
              <li>当キャンペーンは、キャンペーン期間内に初回入金を完了されたお客様に適用され、おひとり様1回のみ申請ができます。</li>
              <li>当キャンペーンは最低3,000円の入金が必要です。</li>
              <li> 入金完了後、入金額が自動的に【Katsu現金ウォレット】に移動され、入金ボーナスは自動的に【Katsuボーナスウォレット】に移動されます。</li>
              <li>すべてのゲームのベットは、【Katsu現金ウォレット】より優先的に使用されゲームを進行します。</li>
              <li>【Katsu現金ウォレット】の残高が0となった場合、【Katsuボーナスウォレット】より使用が開始され、ゲームを進行します。</li>
              <li>【Katsuボーナスウォレット】はベット額が規定の20倍に到達した場合、自動的に【Katsu現金ウォレット】に移動されます。</li>
              <li> 最初の出金申請にはKYC認証を完了させる必要がございます。</li>
              <li>【Kastuボーナスウォレット】を使用した場合、「スロットマシーン、ビデオビンゴ、フィッシングゲーム」での1回のベットが800円を超えることはできません。超過した場合、違反とみなし、すべての関連ボーナスは没収といたします。</li>
              <li>【Kastuボーナスウォレット】を使用した場合、「テーブルゲーム、ライブビデオ」での1回のベットが3,000円を超えることができません。超過した場合、違反とみなし、すべての関連ボーナスは没収といたします。</li>
              <li>【Katsuボーナスウォレット】を使用し、bonus buyまたはfree spinsを購入する場合、ベット額が最高ベット限度規定を超えると違反と見なされ，関連するボーナスは全て没収されます。</li>
              <li> ボーナスのベット反映率：スロット系ゲーム：100%、テーブル系ゲーム：50％、ライブ系ゲーム：20％、スキル系ゲーム：15％</li>
              <li>当キャンペーンのボーナスの利用期間は獲得日から起算し30日間有効で、有効期間内に利用されなかった場合、システムにより【Katsuボーナスウォレット】から自動的に削除されます。</li>
              <li>当キャンペーンは他のキャンペーンと同時に申請することができません。</li>
              <li>当キャンペーンを不正に利用したり、その他の不正行為が発覚した場合、KatsuWINはお客様のすべてのキャンペーン申請を停止し、【Katsuボーナスウォレット】の残高を没収し、アカウントその他の権利を無効にする権利を有します。</li>
              <li>当サイトは、事前の通知なしに当キャンペーンを終了または変更する権利を有します。</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import landing from './landing.vue'
import login from './login.vue'
import forget from './forget.vue'
import deposit from './deposit.vue'

export default {
  name: 'Campaign',
  components: { landing, login, forget, deposit },
  props: {
    prizeRate: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {

  },
  methods: {
    goLogin() {
      this.$store.commit('SET_CAMP_LOGIN_OPEN', true)
    },
    goDeposit() {
      this.$store.commit('SET_CAMP_DEPOSIT_OPEN', true)
    },
    goHome() {
      this.$store.commit('SET_CAMP_LOGIN_OPEN', false)
      this.$store.commit('SET_CAMP_FORGET_OPEN', false)
      this.$store.commit('SET_CAMP_DEPOSIT_OPEN', false)
    }
  }
}
</script>

<style>

</style>
